import { Form, Field } from "react-final-form";
import React, { useCallback } from "react";

const ProjectProposalForm = () => {
    const submitCallback = useCallback((values, form, complete) => {
        complete();
    }, []);

    return (
        <div className="container mt-3" style={{ maxWidth: 500 }}>
            <Form
                onSubmit={submitCallback}
                render={({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="container mt-3" style={{ maxWidth: 500 }}>
                            <div className="mb-3">
                                <div>
                                    <label>Sex</label>
                                </div>



                                <div className="custom-control custom-radio custom-control-inline">
                                    <Field
                                        name="sex"
                                        component="input"
                                        type="radio"
                                        value="male"
                                        className="custom-control-input"
                                        id="male"
                                    />
                                    <label className="custom-control-label" htmlFor="male">
                                        Male
                                    </label>
                                </div>

                                <div className="form__form-group">
                                    <span className="form__form-group-label">Project Type</span>
                                    {projectTypes.map(item => (
                                        <div key={`index_${item.label}`} className="form__form-group form__form-group-field">
                                            <Field
                                                name="project_type"
                                                component={renderRadioButtonField}
                                                label={item.label}
                                                radioValue={item.radioValue}
                                            // initialValue={item.initialValue}
                                            />
                                        </div>
                                    ))}
                                </div>



                                <div className="mb-3 custom-control custom-radio custom-control-inline">
                                    <Field
                                        name="sex"
                                        component="input"
                                        type="radio"
                                        value="female"
                                        className="custom-control-input"
                                        id="female"
                                    />
                                    <label className="custom-control-label" htmlFor="female">
                                        Female
                                    </label>
                                </div>
                            </div>
                            <div className="mb-3">
                                <div>
                                    <label>Favorite seasons</label>
                                </div>
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <Field
                                        name="favoriteSeasons"
                                        component="input"
                                        type="checkbox"
                                        value="winter"
                                        className="custom-control-input"
                                        id="winter"
                                    />
                                    <label className="custom-control-label" htmlFor="winter">
                                        Winter
                                    </label>
                                </div>
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <Field
                                        name="favoriteSeasons"
                                        component="input"
                                        type="checkbox"
                                        value="spring"
                                        className="custom-control-input"
                                        id="spring"
                                    />
                                    <label className="custom-control-label" htmlFor="spring">
                                        Spring
                                    </label>
                                </div>
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <Field
                                        name="favoriteSeasons"
                                        component="input"
                                        type="checkbox"
                                        value="summer"
                                        className="custom-control-input"
                                        id="summer"
                                    />
                                    <label className="custom-control-label" htmlFor="summer">
                                        Summer
                                    </label>
                                </div>
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <Field
                                        name="favoriteSeasons"
                                        component="input"
                                        type="checkbox"
                                        value="autumn"
                                        className="custom-control-input"
                                        id="autumn"
                                    />
                                    <label className="custom-control-label" htmlFor="autumn">
                                        Autumn
                                    </label>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary mb-3">
                                Submit
                            </button>
                        </div>
                    </form>
                )}
            />
        </div>
    );
};


export default ProjectProposalForm;